import { ArchivedBadge } from "@/components/ArchivedBadge";
import { type Label } from "@repo/schema";

/** A limit's label; one archived after the limit was made keeps working and says so. */
export const LabelCell = ({ label }: { label: Label }) => (
  <span className="inline-flex items-center gap-1.5">
    {label.name}
    {label.deletedAt && <ArchivedBadge />}
  </span>
);
